(function () {
  'use strict';

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      return response.json();
    });
  }

  function updateCheckoutButtons(cart) {
    var zeroSubtotal = Number(cart.total_price) === 0;

    // Normal Checkout button
    document
      .querySelectorAll('button[name="checkout"], input[name="checkout"]')
      .forEach(function (button) {
        button.disabled = zeroSubtotal;

        if (zeroSubtotal) {
          button.setAttribute('aria-disabled', 'true');
          button.style.opacity = '0.5';
          button.style.cursor = 'not-allowed';
          button.style.pointerEvents = 'none';
        } else {
          button.removeAttribute('aria-disabled');
          button.style.opacity = '';
          button.style.cursor = '';
          button.style.pointerEvents = '';
        }
      });

    // Shop Pay / accelerated checkout
    document
      .querySelectorAll('.additional-checkout-buttons')
      .forEach(function (container) {
        container.style.display = zeroSubtotal ? 'none' : '';
      });
  }

  // Initial check
  getCart()
    .then(updateCheckoutButtons)
    .catch(function () {});


  // Protect Checkout clicks.
  // This does NOT monitor Add to Cart or quantity changes.
  document.addEventListener('click', function (event) {

    var checkoutButton = event.target.closest(
      'button[name="checkout"], input[name="checkout"]'
    );

    if (!checkoutButton) {
      return;
    }

    getCart()
      .then(function (cart) {

        var zeroSubtotal = Number(cart.total_price) === 0;

        if (zeroSubtotal) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          updateCheckoutButtons(cart);
        }
      })
      .catch(function () {});

  }, true);

})();